import axios from "axios";
const instance = axios.create({
  baseURL: "",
});

instance.interceptors.response.use(
  (response) => {
    return {
      ...response,
      data: {
        success: response?.data?.errorCode === 200,
        data: response?.data?.data,
        originResponse: response.data,
        error:
          response?.data?.errorCode === 200
            ? null
            : new Error(response?.data?.message),
      },
    };
  },
  (error) => {
    return {
      ...error,
      data: {
        success: false,
        data: undefined,
        originResponse: error,
        error: error,
      },
    };
  }
);

export default instance;
